import React from 'react';
import { DecompositionMode } from '../../types';
import { OuvrageType } from '../../../1-bibliotheque-prix/data/ServicesData';

/**
 * Petit label discret indiquant la nature commerciale du prix d'une prestation :
 *   - « F+P » (vert) : prix fourni + posé — ce que la prestation vend au MOE
 *     (mode forfaitaire ou fourni-pose).
 *   - « F »    (bleu) : prix fourniture seule — coût d'achat matière uniquement,
 *     sans main d'œuvre (mode fourniture-seule).
 *
 * Deux modes d'emploi :
 *   - `mode` (DecompositionMode)     → dérivé du bloc, pour les lignes de chiffrage
 *                                       (BlockRow, VentilationCostRow).
 *   - `ouvrageType` (OuvrageType)    → prioritaire si présent, pour les entrées
 *                                       de bibliothèque (dropdowns de recherche).
 *
 * Si les deux sont fournis, `ouvrageType` l'emporte.
 */
export const FPLabel: React.FC<{
  mode?: DecompositionMode;
  ouvrageType?: OuvrageType;
  className?: string;
}> = ({ mode, ouvrageType, className = '' }) => {
  // Priorité : ouvrageType (biblio) > mode (ligne de chiffrage)
  const isFOnly = ouvrageType !== undefined
    ? ouvrageType === 'F'
    : mode === 'fourniture-seule';
  const label = isFOnly ? 'F' : 'F+P';
  const tooltip = isFOnly
    ? 'Fourniture seule — coût d\u2019achat matière (pas de prix vente posé)'
    : 'Fourni + Posé — prix vente incluant matière et main d\u2019œuvre';

  const colorClasses = isFOnly
    ? 'bg-sky-50 text-sky-600 border-sky-200'
    : 'bg-emerald-50 text-emerald-600 border-emerald-200';

  return (
    <span
      title={tooltip}
      className={`inline-flex items-center px-1 py-px rounded text-[9px] font-semibold border flex-shrink-0 ${colorClasses} ${className}`}
    >
      {label}
    </span>
  );
};
